import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

export function FormatMessage({ msg }: { msg: any }) {
    return (
        <Paper sx={{ mb: 3, p: 2, borderRadius: 2, background: '#fafbfc' }} elevation={0}>
            {msg.parts?.map((part: any, i: number) => (
                <Box key={i} sx={{ mt: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                        <b>Part Kind:</b> {part.part_kind}
                        {part.tool_name && (
                            <>
                                {' '}
                                | <b>Tool Name:</b> {part.tool_name}
                            </>
                        )}
                    </Typography>
                    {part.content && (
                        <Box
                            sx={{
                                mt: 0.5,
                                whiteSpace: 'pre-wrap',
                                background: '#f5f5f5',
                                p: 1,
                                borderRadius: 1,
                                fontSize: 15,
                            }}
                        >
                            {Array.isArray(part.content) ? (
                                part.content.map((item: any, index: number) => {
                                    if (typeof item === 'string') {
                                        return <div key={index}>{item}</div>;
                                    } else if (typeof item === 'object' && item !== null) {
                                        if (item.kind === 'image-url' && item.url) {
                                            return (
                                                <div key={index}>
                                                    <img
                                                        src={item.url}
                                                        alt="Attachment"
                                                        style={{ maxWidth: '100%', maxHeight: '200px' }}
                                                    />
                                                </div>
                                            );
                                        }
                                        return <div key={index}>[Object: {JSON.stringify(item, null, 2)}]</div>;
                                    }
                                    return <div key={index}>{String(item)}</div>;
                                })
                            ) : typeof part.content === 'string' ? (
                                part.content
                            ) : (
                                <div>[Content: {JSON.stringify(part.content, null, 2)}]</div>
                            )}
                        </Box>
                    )}
                </Box>
            ))}
            {msg.instructions && (
                <Box sx={{ mt: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                        <b>Instructions:</b>
                    </Typography>
                    <pre
                        style={{
                            background: '#f5f5f5',
                            padding: 8,
                            borderRadius: 4,
                            whiteSpace: 'pre-wrap',
                            fontSize: 13,
                            margin: 0,
                        }}
                    >
                        {msg.instructions}
                    </pre>
                </Box>
            )}
        </Paper>
    );
}
